export default __webpack_public_path__ + "static/media/file-download.cbb44ee2.svg";